import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { IconAlertTriangle } from "@tabler/icons-react";
import styles from "./WarningModal.module.css";

const WarningModal = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "Are you sure you want to proceed?",
  secondaryMessage = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  isDanger = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        className: styles.modalPaper,
        sx: {
          maxWidth: { xs: "95%", sm: "480px" },
          margin: "16px",
        },
      }}
    >
      <Box
        className={`${styles.modalHeader} d-flex justify-content-center align-items-center position-relative pt-4`}
      >
        <Box
          className={`${styles.iconWrapper} ${
            isDanger ? styles.dangerIconWrapper : styles.warningIconWrapper
          } d-flex justify-content-center align-items-center rounded-circle`}
        >
          <IconAlertTriangle
            size={60}
            stroke={2}
            color={isDanger ? "#d32f2f" : "#faad14"}
          />
        </Box>
      </Box>

      <DialogContent className="text-center px-4 py-3">
        <Typography variant="h5" className="fw-bold mb-3">
          {title}
        </Typography>
        <Typography variant="body1" className={styles.modalMessage}>
          {message}
        </Typography>
        {secondaryMessage && (
          <Typography variant="body2" className={styles.secondaryMessage}>
            {secondaryMessage}
          </Typography>
        )}
      </DialogContent>

      <DialogActions className="justify-content-center px-4 pb-4 gap-3 flex-column flex-sm-row">
        <Button
          onClick={onClose}
          className={`${styles.cancelBtn} w-100 w-sm-auto order-2 order-sm-1`}
        >
          {cancelText}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          className={`${
            isDanger ? styles.confirmBtnDanger : styles.confirmBtn
          } border-0 w-100 w-sm-auto order-1 order-sm-2`}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningModal;
